import React, { Component } from 'react'
import { withRouter } from 'react-router'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import Grid from '@material-ui/core/Grid'
import moment from 'moment'
import ButtonBase from '@material-ui/core/ButtonBase'
import CardHeader from '@material-ui/core/CardHeader'
import Card from '@material-ui/core/Card'
import Avatar from '@material-ui/core/Avatar'
import BarIcon from '@material-ui/icons/LocalBar'
import Typography from '@material-ui/core/Typography'
import EuroIcon from '@material-ui/icons/EuroSymbol'
const styles = theme => ({
  card: {
    width: '100%'
  },
  media: {
    height: 194
  },
  action: {
    margin: 0
  },
  expand: {
    transform: 'rotate(0deg)',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest
    }),
    marginLeft: 'auto'
  },
  expandOpen: {
    transform: 'rotate(180deg)'
  },
  avatar: {
    backgroundColor: theme.palette.primary.main
  },
  icon: {
    color: theme.palette.primary.main,
    width: 24,
    height: 24
  }
})
class BarCardComponent extends Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    bar: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired
  }

  handleBarClicked = e => {
    this.props.history.push('/bar/' + this.props.bar.key)
  }
  render() {
    const { bar, classes } = this.props
    if (!bar.currentTransaction) return null
    let total = 0
    if (bar.currentTransaction) {
      if (bar.currentTransaction.products) {
        Object.keys(bar.currentTransaction.products).map(key => {
          total += Number(bar.currentTransaction.products[key].price)
          return null
        })
      }
      if (bar.currentTransaction.pool) {
        total += Number(bar.currentTransaction.pool.total)
        if (bar.currentTransaction.pool.transfert) {
          total += Number(bar.currentTransaction.pool.transfert.total)
        }
      }
    }
    return (
      <Grid item xs={11} sm={6} md={6} lg={4} xl={3}>
        <ButtonBase className={classes.card} onClick={this.handleBarClicked}>
          <Card className={classes.card}>
            <CardHeader
              classes={{
                action: classes.action
              }}
              avatar={
                <Avatar
                  aria-label={bar.name}
                  className={classes.avatar}
                  style={
                    (bar || {}).color ? { backgroundColor: bar.color } : {}
                  }>
                  <BarIcon color="inherit" />
                </Avatar>
              }
              action={
                <Grid
                  className={classes.action}
                  container
                  direction="column"
                  alignItems="center"
                  justify="center">
                  <Grid item>
                    <EuroIcon
                      className={classes.icon}
                      style={{ fontSize: 10 }}
                      color="inherit"
                    />
                    <Typography variant="caption">{`${total.toFixed(
                      2
                    )}`}</Typography>
                  </Grid>
                </Grid>
              }
              title={bar.name}
              subheader={
                <Typography variant="caption" noWrap>
                  {moment(bar.currentTransaction.createdAt).format(
                    'DD/MM - HH:mm:ss'
                  )}
                </Typography>
              }
            />
          </Card>
        </ButtonBase>
      </Grid>
    )
  }
}
export default withRouter(withStyles(styles)(BarCardComponent))



// WEBPACK FOOTER //
// ./src/routes/Home/components/bar/BarCardComponent.js